const cartPageLineitemchange = () => {
  document.addEventListener("DOMContentLoaded", async () => {
    const response = await getCart();
    const cartContent = await response.json();
    const cartItems = cartContent.items;
  
    let refresh = false;
    let numberOfCustomize = 0;
  
    const checkAndUpdateItem = async (item) => {
      const properties = item.properties || {};
      const colorProperty = Object.keys(properties).find(
        (key) => key.includes("Color") && properties[key] != ""
      );
      const lettersProperty = Object.keys(properties).find(
        (key) => key.includes("Letters") && properties[key] != ""
      );
      const preOrderProperty = Object.keys(properties).find(
        (key) => key.includes("Preorder") && properties[key] != ""
      );
  
      const key = item.key;
  
      if (colorProperty && !lettersProperty && preOrderProperty) {
        await addLineItemProperty(key, { Preorder: properties["Preorder"] });
        refresh = true;
      } else if (!colorProperty && lettersProperty && preOrderProperty) {
        await addLineItemProperty(key, { Preorder: properties["Preorder"] });
        refresh = true;
      } else if (
        (colorProperty && !lettersProperty) ||
        (!colorProperty && lettersProperty)
      ) {
        await removeLineItem(key);
        await addLineItem(item.id);
        refresh = true;
      }
  
      if (colorProperty && lettersProperty) {
        numberOfCustomize += 1;
  
        const deliveryProperty = Object.keys(properties).find(
          (key) => key.includes("納期") && properties[key] != ""
        );
  
        if (!deliveryProperty && !preOrderProperty) {
          properties["納期"] = "約1週間";
          await addLineItemProperty(key, properties);
          refresh = true;
        } else if (!deliveryProperty && preOrderProperty) {
          if (!properties["Preorder"].includes("+箔押し: 納期約2週間")) {
            properties["Preorder"] += "+箔押し: 納期約2週間";
            await addLineItemProperty(key, properties);
            refresh = true;
          }
        }

        const custom1 = document.querySelector("[data-customize-id]");
        if (
          custom1 &&
          !cartItems.some((item) => item.id == custom1.dataset.customizeId)
        ) {
          await addLineItem(custom1.dataset.customizeId);
          refresh = true;
        }
      }

      // if (
      //   item.sku.includes("GIFT-") &&
      //   !cartItems.some((item) => !item.sku.includes("GIFT-"))
      // ) {
      //   await removeLineItem(key);
      //   refresh = true;
      // }
    };
  
    const promises = cartItems.map(checkAndUpdateItem);
    await Promise.all(promises);
  
    if (
      cartItems.some((item) => item.sku == "custom-1") &&
      numberOfCustomize <= 0
    ) {
      const custom1 = document.querySelector("[data-customize-id]");
      if (custom1) {
        const custom1Element = cartItems.find(
          (item) => item.id == custom1.dataset.customizeId
        );
        if (custom1Element) {
          await removeLineItem(custom1Element.key);
          refresh = true;
        }
      }
    }
  
    if (refresh) {
      await refreshCart();
    }
  });
};
  
const removeLineItem = async (key) => {
  return await fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates: { [key]: 0 } }),
  });
};

const addLineItem = async (variantId) => {
  return await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
  });
};

const addLineItemProperty = async (key, propertyData) => {
  return await fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id: key, properties: propertyData }),
  });
};

const refreshCart = () => {
  window.location.reload();
};

const getCart = async () => {
  return await fetch("/cart.js", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};
cartPageLineitemchange();